import { createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';
import reduxPender from 'redux-pender';
import modules from 'app/store/modules';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { reportExceptionMiddleware } from 'app/libs/redux-middleware';

// redux-pender는 CJS(exports.default)라 번들러/런타임에 따라 default 형태가 달라진다. interop-safe 처리.
const penderMiddleware = reduxPender.default ?? reduxPender;

const configureStore = () => {
	const store = createStore(
		modules,
		// eslint-disable-next-line no-underscore-dangle
		global.__PRELOADED_STATE__,
		composeWithDevTools({
			actionsDenylist: ['persist', '@@redux-pender'],
		})(applyMiddleware(penderMiddleware(), reportExceptionMiddleware)),
	);
	const persistor = persistStore(store);

	return { store, persistor };
};

export default configureStore;
